import React from 'react';
import MainContainer from '../components/MainContainer';
import { autoresend_sendall } from '../cruds/restApi';

const defaultValue = "Send result will be shown here...";

const Editor = React.createClass({
  displayName: 'Editor',
    handleBatchExport: async function () {
      this.setState({ value: "Be patient, this can take a long time! Working..."});
      const result = await autoresend_sendall();
    this.setState({ value: JSON.stringify(result, null, 4)});
    alert("Done export");
  }, 
  getInitialState: function() { 
    return {
      value: defaultValue
    };
  },
  render: function() {
    return (
      <div>
        <textarea name="textarea" value={this.state.value} />
        <div style={{height:1 +'em'}}></div>
        <span>&nbsp;</span>
        <div><button onClick={this.handleBatchExport}>Batch export</button></div>
      <span>&nbsp;</span>
      </div>
    );
  }
});


const VeriskBatchSend = props => {
  return (
    <MainContainer>
      <div>
        <div id="explanation">
          <h3>This function is critical!</h3>
          <p>Proceed only if you really know what you are doing (read the doc first)</p> 
        </div>
      </div>
      <Editor value="" />
    </MainContainer>
  );
};

export default VeriskBatchSend;



// WEBPACK FOOTER //
// ./src/main/pages/VeriskBatchSend.js